<template>
  <ContentWrap>
    <el-form
      ref="queryFormRef"
      :inline="true"
      :model="queryParams"
      class="-mb-15px"
      label-width="68px"
    >
      <el-form-item label="客人姓名" prop="name">
        <el-input
          v-model="queryParams.name"
          class="!w-240px"
          clearable
          placeholder="请输入客人姓名"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="证件号" prop="idNumber">
        <el-input
          v-model="queryParams.idNumber"
          class="!w-240px"
          clearable
          placeholder="请输入证件号"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery">
          <Icon class="mr-5px" icon="ep:search" />
          搜索
        </el-button>
        <el-button @click="resetQuery">
          <Icon class="mr-5px" icon="ep:refresh" />
          重置
        </el-button>
        <el-button
          v-hasPermi="['hotel:order-guest:create']"
          plain
          type="primary"
          @click="openForm('create')"
        >
          <Icon class="mr-5px" icon="ep:plus" />
          新增
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column align="center" label="客人姓名" prop="name" min-width="100" />
      <el-table-column align="center" label="客人类型" prop="isPrimary" min-width="100">
        <template #default="scope">
          <el-tag v-if="scope.row.isPrimary === 1" type="primary">主客</el-tag>
          <el-tag v-else-if="scope.row.isPrimary === 0" type="info">同行人</el-tag>
          <span v-else class="text-gray-400">-</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="证件类型" prop="idType" min-width="100">
        <template #default="scope">
          <el-tag v-if="scope.row.idType === 'ID_CARD'" type="success">身份证</el-tag>
          <el-tag v-else-if="scope.row.idType === 'PASSPORT'" type="primary">护照</el-tag>
          <el-tag v-else-if="scope.row.idType === 'OTHER'" type="info">其他</el-tag>
          <span v-else class="text-gray-400">-</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="证件号" prop="idNumber" min-width="180" show-overflow-tooltip />
      <el-table-column align="center" label="手机号" prop="phone" min-width="120" />
      <el-table-column align="center" label="性别" prop="gender" min-width="80">
        <template #default="scope">
          <span v-if="scope.row.gender === 0">未知</span>
          <span v-else-if="scope.row.gender === 1">男</span>
          <span v-else-if="scope.row.gender === 2">女</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="入住时间" prop="checkInTime" min-width="160" />
      <el-table-column align="center" label="退房时间" prop="checkOutTime" min-width="160" />
      <el-table-column
        :formatter="dateFormatter"
        align="center"
        label="创建时间"
        prop="createTime"
        width="180"
      />
      <el-table-column align="center" label="操作" width="150" fixed="right">
        <template #default="scope">
          <el-button
            v-hasPermi="['hotel:order-guest:update']"
            link
            type="primary"
            @click="openForm('update', scope.row.id)"
          >
            修改
          </el-button>
          <el-button
            v-hasPermi="['hotel:order-guest:delete']"
            link
            type="danger"
            @click="handleDelete(scope.row.id)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <Dialog v-model="dialogVisible" :title="dialogTitle">
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="100px"
    >
      <el-form-item label="客人姓名" prop="name">
        <el-input v-model="formData.name" placeholder="请输入客人姓名" />
      </el-form-item>
      <el-form-item label="客人类型" prop="isPrimary">
        <el-radio-group v-model="formData.isPrimary">
          <el-radio :value="1">主客</el-radio>
          <el-radio :value="0">同行人</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="证件类型" prop="idType">
        <el-radio-group v-model="formData.idType">
          <el-radio value="ID_CARD">身份证</el-radio>
          <el-radio value="PASSPORT">护照</el-radio>
          <el-radio value="OTHER">其他</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="证件号" prop="idNumber">
        <el-input v-model="formData.idNumber" placeholder="请输入证件号" />
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="formData.phone" placeholder="请输入手机号" />
      </el-form-item>
      <el-form-item label="性别" prop="gender">
        <el-radio-group v-model="formData.gender">
          <el-radio :value="0">未知</el-radio>
          <el-radio :value="1">男</el-radio>
          <el-radio :value="2">女</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button :loading="formLoading" type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { dateFormatter } from '@/utils/formatTime'
import * as OrderGuestApi from '@/api/hotel/orderGuest'

defineOptions({ name: 'HotelOrderGuest' })

const message = useMessage()
const { t } = useI18n()

const loading = ref(true)
const total = ref(0)
const list = ref([])

const queryParams = reactive<any>({
  pageNo: 1,
  pageSize: 20,
  name: undefined,
  idNumber: undefined
})
const queryFormRef = ref()

const getList = async () => {
  loading.value = true
  try {
    const data = await OrderGuestApi.getOrderGuestPage(queryParams)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryFormRef.value.resetFields()
  handleQuery()
}

const dialogVisible = ref(false)
const dialogTitle = ref('')
const formLoading = ref(false)
const formType = ref('')
const formData = ref<OrderGuestApi.OrderGuestVO>({
  id: undefined,
  orderId: 0,
  roomId: undefined,
  name: '',
  idType: 'ID_CARD',
  idNumber: '',
  phone: '',
  gender: 0,
  isPrimary: 1,
  checkInTime: undefined,
  checkOutTime: undefined,
  createTime: undefined as any
})
const formRules = reactive({
  name: [{ required: true, message: '客人姓名不能为空', trigger: 'blur' }],
  isPrimary: [{ required: true, message: '客人类型不能为空', trigger: 'change' }],
  idType: [{ required: true, message: '证件类型不能为空', trigger: 'change' }]
})
const formRef = ref()

const openForm = async (type: string, id?: string | number) => {
  dialogVisible.value = true
  dialogTitle.value = t('action.' + type)
  formType.value = type
  resetForm()
  if (id) {
    formLoading.value = true
    try {
      formData.value = await OrderGuestApi.getOrderGuest(id)
    } finally {
      formLoading.value = false
    }
  }
}

const submitForm = async () => {
  if (!formRef) return
  const valid = await formRef.value.validate()
  if (!valid) return
  formLoading.value = true
  try {
    const data = formData.value
    if (formType.value === 'create') {
      await OrderGuestApi.createOrderGuest(data)
      message.success(t('common.createSuccess'))
    } else {
      await OrderGuestApi.updateOrderGuest(data)
      message.success(t('common.updateSuccess'))
    }
    dialogVisible.value = false
    await getList()
  } finally {
    formLoading.value = false
  }
}

const resetForm = () => {
  formData.value = {
    id: undefined,
    orderId: 0,
    roomId: undefined,
    name: '',
    idType: 'ID_CARD',
    idNumber: '',
    phone: '',
    gender: 0,
    isPrimary: 1,
    checkInTime: undefined,
    checkOutTime: undefined,
    createTime: undefined as any
  }
  formRef.value?.resetFields()
}

const handleDelete = async (id: string | number) => {
  try {
    await message.delConfirm()
    await OrderGuestApi.deleteOrderGuest(id)
    message.success(t('common.delSuccess'))
    await getList()
  } catch {}
}

onMounted(() => {
  getList()
})
</script>
